// ISP "door fee" (Right-of-Entry) income model — the single source of truth
// shared by the affordable-housing ROI calculator and the pipeline cards so the
// numbers always match. Revenue-per-unit steps up at the 100-unit tier.
export const DOOR_FEE_RPU_100PLUS = 300;
export const DOOR_FEE_RPU_BASE = 250;
export const DOOR_FEE_TIER_THRESHOLD = 100;

export function doorFeeRpu(units) {
    return (units || 0) >= DOOR_FEE_TIER_THRESHOLD ? DOOR_FEE_RPU_100PLUS : DOOR_FEE_RPU_BASE;
}

export function doorFeeIncome(units) {
    const u = units || 0;
    return u * doorFeeRpu(u);
}
